import { render, staticRenderFns } from "./UpdateRoutePrice.vue?vue&type=template&id=e7f1c22c&"
import script from "./UpdateRoutePrice.vue?vue&type=script&lang=js&"
export * from "./UpdateRoutePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports